// extracted by mini-css-extract-plugin
export default {"sliderarea":"Slider_sliderarea__Yk-06","heading":"Slider_heading__PJnSU","slider-button":"Slider_slider-button__Ee+f2"};